export default function SectionHeader(props: { title: string; subtitle?: string; kicker?: string }) {
  return (
    <div>
      {props.kicker ? (
        <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
          <span className="h-2 w-2 rounded-full bg-primary" />
          <span>{props.kicker}</span>
        </div>
      ) : null}
      <h2 className="mt-4 text-2xl font-semibold tracking-tight md:text-3xl">{props.title}</h2>
      {props.subtitle ? <p className="mt-2 max-w-3xl text-white/65">{props.subtitle}</p> : null}
    </div>
  )
}

